import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { LoggerService } from '../services/logger.service';
import { AppSettingsService } from '../services/app-settings.service';

const DEV_AUTH_ENVIRONMENTS = new Set(['development', 'dev', 'test', 'preview']);

@Injectable({
  providedIn: 'root'
})
export class DevOnlyGuard implements CanActivate {
  constructor(
    private router: Router,
    private logger: LoggerService,
    private appSettings: AppSettingsService
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    try {
      const settings = await this.appSettings.loadSettings();
      const environment = settings.environment?.trim().toLowerCase();

      if (!environment || !DEV_AUTH_ENVIRONMENTS.has(environment)) {
        this.logger.error('DevOnlyGuard', 'canActivate', 'Attempted to access dev-only route outside an enabled lower environment');
        return this.router.parseUrl('/login');
      }

      if (settings.enableDevAuth !== true) {
        this.logger.warn('DevOnlyGuard', 'canActivate', 'Dev auth is disabled in runtime config');
        return this.router.parseUrl('/login');
      }

      this.logger.info('DevOnlyGuard', 'canActivate', 'Dev auth access granted');
      return true;
    } catch (error) {
      this.logger.error('DevOnlyGuard', 'canActivate', 'Error checking dev auth settings', error);
      return this.router.parseUrl('/login');
    }
  }
}
